import React, { forwardRef } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Package, Cpu, Factory } from "lucide-react";
import { formatDate } from "./constants";

const BatchRow = forwardRef(({ batch, isLast }, ref) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div
      ref={ref}
      onClick={() => navigate(`/v2/admin/manufacturing/batches/${batch.id}`)}
      className={`flex cursor-pointer items-center justify-between px-4 py-3 transition duration-150 hover:bg-[#FAFAFA] ${
        !isLast ? "border-b border-[#F3F4F6]" : ""
      }`}
    >
      <div className="flex items-center gap-3">
        <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-[#F3F4F6]">
          <Package size={18} className="text-[#6B7280]" />
        </div>
        <div>
          <p className="text-sm font-medium text-[#111827]">{batch.code}</p>
          <p className="text-xs text-[#6B7280]">
            {batch.cm_name || t("admin.manufacturing.batchRow.noManufacturer")}
          </p>
        </div>
      </div>

      <div className="flex items-center gap-8">
        <div className="flex items-center gap-1.5 text-xs text-[#6B7280]">
          <Cpu size={12} />
          <span>{batch.hw_revision || "-"}</span>
        </div>
        <div className="flex items-center gap-1.5 text-xs text-[#6B7280]">
          <Factory size={12} />
          <span>
            {t("admin.manufacturing.batchRow.units", {
              allocated: (batch.wearable_count ?? 0).toLocaleString(),
              planned: (batch.planned_quantity ?? 0).toLocaleString(),
            })}
          </span>
        </div>
        <span className="w-24 text-right text-xs text-[#9CA3AF]">
          {formatDate(batch.created_at)}
        </span>
      </div>
    </div>
  );
});

BatchRow.displayName = "BatchRow";

export default BatchRow;
